import { Link, useLocation } from "react-router-dom";
import { Home } from "lucide-react";

// Reusable "Retour à l'accueil" CTA. Auto-hides on the home page.
// Usage:
//   <BackHomeButton />                  // floating top-left (default)
//   <BackHomeButton position="inline" /> // inline, no fixed positioning
export default function BackHomeButton({
  position = "fixed",
  testid = "back-home-button",
}) {
  const location = useLocation();
  if (location.pathname === "/") return null;
  const cls =
    position === "fixed"
      ? "fixed top-[68px] sm:top-4 left-2 sm:left-4 z-40"
      : "inline-flex";
  return (
    <Link
      to="/"
      data-testid={testid}
      className={`${cls} items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/40 border border-white/10 backdrop-blur-sm text-white/70 hover:text-cyan-300 hover:border-cyan-400/40 text-xs font-mono-stat uppercase tracking-widest transition-all`}
    >
      <Home className="w-3.5 h-3.5" />
      <span className="hidden sm:inline">Retour à l&apos;accueil</span>
      <span className="sm:hidden">Accueil</span>
    </Link>
  );
}
